"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfCoverageSelectorModal = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importStar(require("react"));
var use_fuzzy_1 = require("../../utils/hooks/use-fuzzy");
var line_of_coverage_card_1 = require("../line-of-coverage-card");
function LineOfCoverageSelectorModal(_a) {
    var error = _a.error, header = _a.header, initialSelectedLineOfCoverageUuids = _a.initialSelectedLineOfCoverageUuids, isOpen = _a.isOpen, linesOfCoverage = _a.linesOfCoverage, _b = _a.loading, loading = _b === void 0 ? false : _b, onSubmit = _a.onSubmit, onToggle = _a.onToggle, _c = _a.required, required = _c === void 0 ? false : _c, submitText = _a.submitText, _d = _a.submitting, submitting = _d === void 0 ? false : _d, type = _a.type;
    var _e = use_fuzzy_1.useFuzzy(linesOfCoverage, {
        keys: [
            'type',
            'displayName',
            'policy.type',
            'policy.details.displayName',
            'policy.name',
            'policy.policyNumber',
            'policy.carrier.name',
            'policy.details.thirdParty',
        ],
    }), results = _e.result, search = _e.search, keyword = _e.keyword;
    var _f = react_1.useState(initialSelectedLineOfCoverageUuids), selectedLineOfCoverageUuids = _f[0], setSelectedLineOfCoverageUuids = _f[1];
    react_1.useEffect(function () {
        setSelectedLineOfCoverageUuids(initialSelectedLineOfCoverageUuids);
    }, [initialSelectedLineOfCoverageUuids]);
    function handleSelection(lineOfCoverage) {
        var _a;
        if (type === 'multi') {
            setSelectedLineOfCoverageUuids(function (currentSelectedLineOfCoverageUuids) {
                var _a;
                return currentSelectedLineOfCoverageUuids.includes(lineOfCoverage.uuid || '')
                    ? currentSelectedLineOfCoverageUuids.filter(function (lineOfCoverageUuid) { return lineOfCoverageUuid !== lineOfCoverage.uuid; })
                    : currentSelectedLineOfCoverageUuids.concat([(_a = lineOfCoverage.uuid) !== null && _a !== void 0 ? _a : '']);
            });
            return;
        }
        setSelectedLineOfCoverageUuids([(_a = lineOfCoverage.uuid) !== null && _a !== void 0 ? _a : '']);
    }
    function isSelected(lineOfCoverage) {
        var _a;
        return selectedLineOfCoverageUuids.includes((_a = lineOfCoverage.uuid) !== null && _a !== void 0 ? _a : '');
    }
    function handleSubmit() {
        onSubmit(selectedLineOfCoverageUuids);
    }
    return (react_1.default.createElement(core_ui_1.Modal, { isOpen: isOpen, onToggle: onToggle, width: "600px" },
        react_1.default.createElement(core_ui_1.ModalBody, null,
            react_1.default.createElement(core_ui_1.ModalHeader, { titleText: header, onClose: onToggle }),
            react_1.default.createElement(core_ui_1.ObjectSelector, { loading: loading, error: error, placeholder: "No lines of coverage available", onSearchInputChange: search, searchInput: keyword }, (results === null || results === void 0 ? void 0 : results.length) > 0 &&
                results.map(function (lineOfCoverage) { return (react_1.default.createElement(line_of_coverage_card_1.LineOfCoverageCard, { key: lineOfCoverage.uuid, lineOfCoverage: lineOfCoverage, onSelect: function () { return handleSelection(lineOfCoverage); }, isSelected: isSelected(lineOfCoverage), selectType: type === 'multi' ? 'checkbox' : 'radio' })); })),
            react_1.default.createElement(core_ui_1.ModalFooter, { showBorder: true },
                react_1.default.createElement(core_ui_1.Stack, { gap: 8, direction: "horizontal", justifyContent: "flex-end" },
                    react_1.default.createElement(core_ui_1.Button, { onClick: onToggle, loading: submitting, size: "secondary" }, "Cancel"),
                    react_1.default.createElement(core_ui_1.Button, { onClick: handleSubmit, loading: submitting, disabled: required ? selectedLineOfCoverageUuids.length === 0 : false }, typeof submitText === 'function' ? submitText(selectedLineOfCoverageUuids) : submitText))))));
}
exports.LineOfCoverageSelectorModal = LineOfCoverageSelectorModal;
